module.exports = __webpack_public_path__ + "static/media/Avatars_Other_New-13.bfd4216b.jpg";